import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { undoDataErrorEndpoint } from '../../../common/endpoints';

export const undoDataErrorApi = createApi(undoDataErrorEndpoint, 'POST');

const UndoDataError = createSlice({
  name: 'UndoDataError',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(undoDataErrorApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(undoDataErrorApi.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(undoDataErrorApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default UndoDataError.reducer;